import React, { useEffect } from 'react';
import './QueueStatusConfirmationModal.css';

const QueueStatusConfirmationModal = ({ isOpen, onClose, onConfirm, queueName, newStatus }) => {
  useEffect(() => {
    console.log('Modal mounted/updated:', { isOpen, queueName, newStatus });
  }, [isOpen, queueName, newStatus]);

  if (!isOpen) {
    console.log('Modal not rendering because isOpen is false');
    return null;
  }

  console.log('Modal rendering with props:', { isOpen, queueName, newStatus });

  const handleConfirm = () => {
    console.log('Confirm clicked with status:', newStatus);
    onConfirm();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="queue-status-modal" onClick={e => e.stopPropagation()}>
        <div className="confirm-entry-modal">
          <p className="h1style">
            {newStatus === 'active' ? 'Enable' : 'Disable'} Queue ({queueName})
          </p>
          <p className="h2style">Are you sure?</p>
          <p className="consequence-text">
            {newStatus === 'active' 
              ? 'This will allow new customers to be assigned to this queue.' 
              : 'This will prevent new customers from being assigned to this queue.'}
          </p>
          <div className="actions">
            <button className="cancel-button" onClick={onClose}>Cancel</button>
            <button 
              className="confirm-button"
              onClick={handleConfirm}
            >
              {newStatus === 'active' ? 'Enable' : 'Disable'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueueStatusConfirmationModal;
